import React, { ReactNode } from "react";
import { Grid, Paper, Stack, Typography } from "@mui/material";
import { useUser } from "../../contexts/UserProvider";
import { TMode } from "../../hooks/useModeColor";
import ToggleIconLink from "../../Components/ToggleIconLink";

interface IControlPanelProps {
  id: number;
  mode: TMode;
  title: string;
  isToggle?: boolean;
  state?: string;
  children?: ReactNode;
}

const ControlPanel = (props: IControlPanelProps) => {
  const { id, mode, title, isToggle, state, children } = props;
  const { user } = useUser();

  // TODO: was <Grid xs={4} sm={3} sx={{ textAlign: "center" }}>
  return (
    <Grid size={4} sx={{ textAlign: "center" }}>
      <Paper
        sx={{ bgcolor: `${mode}.main`, color: `${mode}.text` }}
        data-cy={`control-${id}`}
      >
        <Typography sx={{ fontSize: 14 }} data-cy="control-name">
          {title}
        </Typography>
        <Stack direction="row" justifyContent="space-evenly" padding={0.5}>
          {children}
          {isToggle && user?.is_admin && (
            <ToggleIconLink
              to={`/controls/${id}/timers`}
              name={"calendar-clock"}
            />
          )}
          {user?.is_admin && (
            <ToggleIconLink
              to={`/controls/${id}`}
              name={"pencil"}
              data-cy="control-edit"
            />
          )}
        </Stack>
        <Typography sx={{ fontSize: 12, fontWeight: "bold" }}>
          {state || <span>&nbsp;</span>}
        </Typography>
      </Paper>
    </Grid>
  );
};

export default ControlPanel;
